// =============================================================
// DocViewerModal.jsx — inline PDF viewer modal
//
// Usage:
//   const [viewerState, setViewerState] = useState(null);
//   // viewerState = { doc, sasUrl } | null
//   <DocViewerModal viewerState={viewerState} onClose={() => setViewerState(null)} />
// =============================================================
import { B, radius, font, weight, space } from '../../constants/brand';
import { overlayStyle, dialogStyle, Icon } from '../ui';

export const DocViewerModal = ({ viewerState, onClose }) => {
  if (!viewerState) return null;
  const { doc, sasUrl } = viewerState;

  return (
    <div
      style={{ ...overlayStyle, zIndex: 1100 }}
      onClick={onClose}
    >
      <div
        style={{
          ...dialogStyle(1100),
          width: '92vw', height: '90vh', maxHeight: '90vh',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '12px 20px', borderBottom: `1px solid ${B.border}`, flexShrink: 0,
        }}>
          <div style={{ fontSize: font.md, fontWeight: weight.bold, color: B.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {doc.fileName}
          </div>
          <div style={{ display: 'flex', gap: space.sm, flexShrink: 0, marginLeft: 12 }}>
            <a
              href={sasUrl}
              download={doc.fileName}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                padding: '5px 12px', borderRadius: radius.md, fontSize: font.sm, fontWeight: weight.semibold,
                color: B.navy, textDecoration: 'none',
                border: `1px solid ${B.border}`, background: B.surface,
              }}
            >
              <Icon name="download" size={14} /> Download
            </a>
            <button
              onClick={onClose}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                padding: '5px 12px', borderRadius: radius.md, fontSize: font.sm, fontWeight: weight.semibold,
                color: B.textMd, background: B.surface, border: `1px solid ${B.border}`,
                cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              <Icon name="close" size={14} /> Close
            </button>
          </div>
        </div>

        {/* PDF iframe */}
        <iframe
          src={sasUrl}
          title={doc.fileName}
          style={{ flex: 1, border: 'none', width: '100%' }}
        />
      </div>
    </div>
  );
};
